










import { Vue, Component } from 'vue-property-decorator';
import EquiposBase from '@/pantallas/Conecta/Equipos/Equipos.vue';

@Component({ components: { EquiposBase } })
export default class Equipos extends Vue {}
